<template>
  <div>
    <PlaceholderPage 
      title="Catatan Baca" 
      :icon="['fas', 'sticky-note']"
      message="Halaman ini akan menampilkan catatan dan highlight yang telah Anda buat saat membaca. Anda dapat mengelola, mengedit, dan mengorganisir catatan Anda berdasarkan buku."
    />
  </div>
</template>

<script>
import PlaceholderPage from '@/components/PlaceholderPage.vue'

export default {
  name: 'ReadingNotes',
  components: {
    PlaceholderPage
  }
}
</script>